import React from "react"
// components
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"
import { RemoveRowButton } from "app/static/frontend/sheets/components/cells/MantineCells/RemoveRowButton"
import { createStyles } from "@mantine/core"

const useStyles = createStyles((theme) => ({
    indexCell: {
        "& button.mantine-Button-root": {
            display: "none",
        },
        "&.can-remove-rows:hover": {
            "& button.mantine-Button-root": {
                display: "block !important",
                backgroundColor: "transparent",
                margin: "auto",
                border: "none",
            },
            "& .row-index": {
                display: "none !important",
            },
        },
    },
    rowEven: {
        backgroundColor: `${theme.colors.gray[1]}`,
        "&:hover": {
            backgroundColor: `${theme.colors.violet[3]}`,
        },
    },
}))

export const IndexCell: React.FC<IndexCellProps> = ({
    canRemoveRows,
    id,
    patchSavedSearch,
    rowIndex,
    rows,
    isIndexCell,
    ...props
}) => {
    const { classes, cx } = useStyles()
    return (
        <CellWrapper
            {...props}
            isIndexCell={isIndexCell}
            className={cx(classes.indexCell, {
                "can-remove-rows": canRemoveRows,
                [classes.rowEven]: rowIndex % 2 !== 0,
            })}
        >
            <span className="row-index">{rowIndex + 1}</span>
            <RemoveRowButton
                datumId={props?.original?.id}
                id={id}
                rowIndex={rowIndex}
                rows={rows}
                removeRow={props.removeRow}
                dataPlumId="sheets-minus-sign"
            />
        </CellWrapper>
    )
}

interface IndexCellProps {
    canRemoveRows: boolean
    id: string
    patchSavedSearch?: (id: string, data: any) => void
    rowIndex: number
    rows: any[]
    isIndexCell?: boolean
    removeRow: (id: string, datumId: number | string) => void
    original?: { id: string }
}
